export default "__VITE_ASSET__a7b18c49__"